import { createContext } from 'react';

const CoreFormContext = createContext(null);

export default CoreFormContext;
